import { PayloadAction } from '@reduxjs/toolkit';

import { QuantitySavingsQuote, QuantitySavingsState } from 'editor/src/store/quantitySavings/types';

const setQuantitySavingsQuoteReducer = (
  state: QuantitySavingsState,
  action: PayloadAction<QuantitySavingsQuote | null>,
) => {
  const quote = action.payload;
  if (!quote) {
    state.quote = undefined;
    state.pendingQuantity = undefined;
    return;
  }
  // Steppers fire faster than the host answers, so a quote for a quantity the shopper has already
  // moved past would show figures for the wrong number of items.
  if (quote.sequence < state.sequence) {
    return;
  }
  state.quote = quote;
  state.sequence = quote.sequence;
  state.pendingQuantity = undefined;
  state.lastQuantity = quote.quantity;
};

export default setQuantitySavingsQuoteReducer;
